
(function ($, document) {

    $(document).ready(function () {
        $(document).on('click', '#top', function (e) {
            e.preventDefault();
            $.scrollTo(0, 800);
        });

        $(document).on('click', '.scroll-to', function (e) {
            e.preventDefault();
            $(window).scrollTo(
                $(this).attr("href"),
                1000,
                {
                    easing: 'swing',
                    queue: true,
                    axis: 'xy'
                }
            );
        });
    });

})(jQuery, document);